export const enum RequestStatus {
    success = 'success',
    error = 'error',
    empty = 'empty',
    loading = 'loading'
}

export const enum DeliveryRole {
    address_es = 'en la dirección de entrega',
    address_es_prefix = 'en la dire',
    address_pr = 'no endereço de entrega',
    branch_es = 'entrega en agencia',
    branch_pr = 'entrega em centro de apoio'
}
